module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('app-header'), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "150px"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "h3-sub-title bold orange"
  }, [_vm._v("Pour tout produit alcoolisé :")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "h3-sub-title bold orange"
  }, [_vm._v("Pour les \"boissons sucrées\" et produits alimentaires type confiserie :")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "h3-sub-title bold orange"
  }, [_vm._v("Pour tout produit lié aux jeux d'argent, paris en ligne (ex : PMU, FDJ, jeux de grattages, ...) :")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "h3-sub-title bold orange"
  }, [_vm._v("Pour tout produit lié au tabac (filtres, papier, tubes, cigarettes/cigares/...) ou à la Vape :")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "500px"
    }
  }), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "arrow"
  }), _vm._v(" "), _c('div', {
    staticClass: "h2-arrow"
  }, [_vm._v("MENTIONS"), _c('br'), _vm._v("OBLIGATOIRES")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nota-bene col-md-9"
  }, [_c('div', {
    staticClass: "h4-sub-title-medium"
  }, [_vm._v("Pour rappel, votre-espace.bimediatv.com est uniquement dédié à la diffusion de messages d'information et/ou de promotion de votre point de vente et des produits à disposition.")]), _vm._v(" "), _c('div', {
    staticClass: "h4-sub-title-medium"
  }, [_vm._v("Vous êtes tenus de connaître et respecter les lois en vigueur.")]), _vm._v(" "), _c('div', {
    staticClass: "h4-sub-title-medium"
  }, [_vm._v("Vous trouverez ci-dessous l'ensemble des mentions légales à intégrer à toute communication publicitaire sous le coup de la Loi Sapin et de la loi Santé 2015 notamment.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "bold underline"
  }, [_vm._v("\n      \"L’abus d’alcool est dangereux pour la santé. A consommer avec modération\"")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-12"
  }, [_vm._v("\n        l'un des 4 messages sanitaires suivants suivi de l'adresse du site internet "), _c('a', {
    staticClass: "bold underline",
    staticStyle: {
      "color": "var(--fourth-color)"
    },
    attrs: {
      "href": "http://www.mangerbouger.fr",
      "target": "_blank"
    }
  }, [_vm._v("www.mangerbouger.fr")]), _vm._v(" :\n        "), _c('ul', [_c('li', {
    staticClass: "orange-list bold"
  }, [_vm._v("Pour votre santé, mangez au moins cinq fruits et légumes par jour ; "), _c('a', {
    staticClass: "bold underline",
    staticStyle: {
      "color": "var(--fourth-color)"
    },
    attrs: {
      "href": "http://www.mangerbouger.fr",
      "target": "_blank"
    }
  }, [_vm._v("www.mangerbouger.fr")])]), _vm._v(" "), _c('li', {
    staticClass: "orange-list bold"
  }, [_vm._v("Pour votre santé, pratiquez une activité physique régulière ; "), _c('a', {
    staticClass: "bold underline",
    staticStyle: {
      "color": "var(--fourth-color)"
    },
    attrs: {
      "href": "http://www.mangerbouger.fr",
      "target": "_blank"
    }
  }, [_vm._v("www.mangerbouger.fr")])]), _vm._v(" "), _c('li', {
    staticClass: "orange-list bold"
  }, [_vm._v("Pour votre santé, évitez de manger trop gras, trop sucré, trop salé ; "), _c('a', {
    staticClass: "bold underline",
    staticStyle: {
      "color": "var(--fourth-color)"
    },
    attrs: {
      "href": "http://www.mangerbouger.fr",
      "target": "_blank"
    }
  }, [_vm._v("www.mangerbouger.fr")])]), _vm._v(" "), _c('li', {
    staticClass: "orange-list bold"
  }, [_vm._v("Pour votre santé, évitez de grignoter entre les repas ; "), _c('a', {
    staticClass: "bold underline",
    staticStyle: {
      "color": "var(--fourth-color)"
    },
    attrs: {
      "href": "http://www.mangerbouger.fr",
      "target": "_blank"
    }
  }, [_vm._v("www.mangerbouger.fr")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-12"
  }, [_vm._v("\n        l'un des 2 messages sanitaires suivants :\n        "), _c('ul', [_c('li', {
    staticClass: "orange-list bold"
  }, [_vm._v("\"Famille, vie sociale, santé financière. Etes-vous prêt à tout miser ? Pour être aidé, appelez le 09-74-75-13-13 (appel non surtaxé)\"")]), _vm._v(" "), _c('li', {
    staticClass: "orange-list bold"
  }, [_vm._v("\"Jouer comporte des risques : endettement, isolement, dépendance. Pour être aidé, appelez le 09-74-75-13-13 (appel non surtaxé)\"")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-12 columns"
  }, [_vm._v("\n      Attention depuis le 31 janvier 2016, toute "), _c('span', {
    staticClass: "bold underline"
  }, [_vm._v("publicité directe ou indirecte")]), _vm._v(" en faveur du "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("tabac")]), _vm._v(", des "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("produits du tabac")]), _vm._v(" ou "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("des ingrédients")]), _vm._v(" définis au deuxième alinéa de "), _c('a', {
    staticClass: "bold underline",
    staticStyle: {
      "color": "var(--fourth-color)"
    },
    attrs: {
      "href": "http://www.legifrance.gouv.fr/affichCodeArticle.do?cidTexte=LEGITEXT000006072665&idArticle=LEGIARTI000006688198&dateTexte=&categorieLien=cid",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("l'article L. 3511-1")])]), _vm._v(" du Code de la Santé Publique est interdite. Seules sont permises les "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("affichettes")]), _vm._v(" relatives aux "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("dispositifs électroniques de vapotage")]), _vm._v(" et aux flacons de recharge qui leur sont associés, disposées à l’intérieur des établissements les commercialisant "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("et non visibles de l’extérieur")]), _vm._v(".\n    ")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1c3fe9b2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c3fe9b2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MentionsLegales.vue
// module id = 190
// module chunks = 1